import React from "react";
import Styles from "./index.module.scss";
import useRequest from "../../../utils/useRequest";
import { getStudPaper2 } from "../../../service/homework";
import PageHomeworkDetailRows from "../component/Rows";

export interface UrlParams {
    paperId: string;
    studentId: string;
}

interface PageHomeworkReviewProps {
    match: { params: UrlParams };
}

export default function PageHomeworkReview({ match }: PageHomeworkReviewProps) {
    const { paperId, studentId } = match.params;

    const [data, { loading }] = useRequest(
        () => getStudPaper2({ paperId, studentId }),
        {},
        [paperId, studentId]
    );

    return (
        <div className={Styles.root}>
            <div
                style={{
                    color: "red",
                    fontSize: 16,
                    background: "#fff",
                    padding: "10px 30px"
                }}>
                <span style={{ color: "#333", paddingRight: 50 }}>
                    姓名: {data?.studentName}
                </span>
                总分: {data?.score}
            </div>

            <PageHomeworkDetailRows
                paperId={paperId}
                studentId={studentId}
                scoreHandler={() => {}}
                data={data}
                loading={loading}
            />
        </div>
    );
}
